import api from "@/api";

export default {
    methods: {
        async getNewsThumbnail(newsPostData) {

            let url = newsPostData.imageUrl
          
            let res = null
            try {
              res = await api.getDriveItemThumbnail(url)
            } catch (error) {
              url = newsPostData.fallbackImageUrl
              res = await api.getDriveItemThumbnail(url)
            }

            return res;
        },
    }
}


// WEBPACK FOOTER //
// ./src/mixins/SharepointMixin.js